<template>
  <div>
    <table class="table table-sm table-bordered table-striped mb-2">
      <thead>
        <tr>
          <th>ชื่อ-สกุล</th>
          <th>โทรศัพท์</th>
          <th v-if="editMode" class="text-center">การกระทำ</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(_, index) in value" :key="index">
          <td>
            <b-form-input v-if="editMode" v-model.trim="value[index].name" size="sm" />
            <span v-else>{{ value[index].name }}</span>
          </td>
          <td>
            <b-form-input v-if="editMode" v-model.trim="value[index].tel" size="sm" />
            <span v-else>{{ value[index].tel }}</span>
          </td>
          <td v-if="editMode" width="80" class="text-center">
            <b-button variant="outline-danger" size="sm" @click="deletePerson(index)">ลบ</b-button>
          </td>
        </tr>
        <tr v-if="!value.length">
          <td class="text-center text-muted" colspan="3">
            ไม่มีข้อมูล
          </td>
        </tr>
      </tbody>
    </table>

    <b-button v-if="editMode" size="sm" variant="primary" @click.prevent="addPerson"><font-awesome-icon icon="plus-circle" />เพิ่มผู้ประสานงานโครงการ</b-button>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Array, required: true },
    editMode: { type: Boolean, required: false, default: true }
  },
  methods: {
    addPerson () {
      this.value.push({ name: '', tel: '' })
    },
    deletePerson (index) {
      this.$delete(this.value, index)
    }
  }
}
</script>

<style lang="scss" scoped>
div {
  font-size: $font-size-base * 0.9;
}
</style>
